var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditcard = function SvgCreditcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.445 6H4.555A4.555 4.555 0 0 0 0 10.555v27.594a4.555 4.555 0 0 0 4.555 4.555h38.89A4.555 4.555 0 0 0 48 38.149V10.555A4.555 4.555 0 0 0 43.445 6ZM4.555 8.405h38.89a2.133 2.133 0 0 1 2.134 2.134v3.296h-43.2v-3.28a2.133 2.133 0 0 1 2.176-2.15ZM43.445 40.3H4.555a2.133 2.133 0 0 1-2.134-2.134V21.152h43.2v16.997a2.133 2.133 0 0 1-2.176 2.15Z"
  })));
};
export default SvgCreditcard;